<template>
  <section v-if="dataList.length >0" class="my-type-character">
    <div class="wrap">
      <h4 class="my-type-tit">많이 본 인물</h4>
      <div id="template-personlist" class="person-wrap swiper-container">
        <swiper :options="swiperOptions">
          <swiper-slide v-for="(person, index) in dataList" :key="index" class="person-list">
            <a @click.prevent="moveToSearch(person.persionname)" href="#">
              <p class="f-txt">{{ person.persionname }}</p>
              <p class="t-txt">{{ viewCount(person.viewcount) }}편</p>
            </a>
          </swiper-slide>
        </swiper>
        <div :id="'swiper-button-prev-person'" class="swiper-button-prev"></div>
        <div :id="'swiper-button-next-person'" class="swiper-button-next"></div>
      </div>
    </div>
  </section>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import _ from 'lodash'
import { PATH_NAME_SEARCH } from '@/common/resources/router.const'
export default {
  components: {
    swiper,
    swiperSlide
  },
  props: {
    dataList: {
      type: Array
    }
  },
  data () {
    return {
      swiperOptions: {
        spaceBetween: 32,
        slidesPerView: 6,
        slidesPerGroup: 6,
        nextButton: '#swiper-button-next-person',
        prevButton: '#swiper-button-prev-person',
        onTouchEnd: (swiper) => {
          this.$nextTick(() => {
            const idx = _.get(swiper, 'clickedIndex', '')
            if (idx !== '') this.moveToSearch(this.dataList[idx].persionname)
          })
        }
      }
    }
  },
  methods: {
    viewCount (count) {
      return count ? count.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,') : 0
    },
    moveToSearch (searchWord) {
      this.$router.push({
        name: PATH_NAME_SEARCH,
        query: {
          searchWord: searchWord
        }
      })
    }
  }
}
</script>
